export const GET_COURSES_BY_PROGRAM_ID = "GET_COURSES_BY_PROGRAM_ID";
export const GET_COURSES_BY_ID = "GET_COURSES_BY_ID";
export const GET_TASK_DETAILS_BY_ID = "GET_TASK_DETAILS_BY_ID";
export const GET_STUDENT_SPECIFIC_DATA = "GET_STUDENT_SPECIFIC_DATA";
